import { auth } from './firebaseSetUp';
import { isSelfHosted } from '../config/infra';
import { getSelfHostedUser } from '../api/selfHostedAuth';

export interface CurrentAuthUser {
  uid: string;
  email?: string | null;
  displayName?: string | null;
}

/** Firebase `currentUser` or self-hosted session — use instead of `auth.currentUser`. */
export function getCurrentAuthUser(): CurrentAuthUser | null {
  if (isSelfHosted) {
    const stored = getSelfHostedUser();
    if (!stored?.uid) return null;
    return {
      uid: stored.uid,
      email: stored.email,
      displayName: stored.displayName,
    };
  }
  const user = auth.currentUser;
  if (!user) return null;
  return {
    uid: user.uid,
    email: user.email,
    displayName: user.displayName,
  };
}
